import { youtubeEmbedUrl, type UpgradeVideo } from "@roof-hawk/core";
import { useState } from "react";

/**
 * A manufacturer's video, in an upgrade's box on the proposal.
 *
 * A play button first, and YouTube only once it is tapped: until then the
 * customer's page asks nothing of anybody else's server, the same reason its
 * fonts are self-hosted. Tapping it swaps in the player, already playing.
 * See `upgradeVideos.ts` in packages/core.
 */
export function UpgradeVideoPlayer({ video }: { video: UpgradeVideo }) {
  const [playing, setPlaying] = useState(false);
  return (
    <div className="pdoc-uvideo">
      {playing ? (
        <iframe
          src={youtubeEmbedUrl(video)}
          title={video.title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      ) : (
        <button
          type="button"
          className="pdoc-uvideo-play"
          aria-label={`Play video: ${video.title}`}
          onClick={() => setPlaying(true)}
        >
          <span className="icon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path d="M8 5v14l11-7z" />
            </svg>
          </span>
          <span className="label">
            <small>Watch the video</small>
            {video.title}
          </span>
        </button>
      )}
    </div>
  );
}
